import { ColorMode, Text } from '@chakra-ui/react';
import { WEEK_DAYS } from '../../../../lib';
import type { ICalendarPlusSettings } from '../../../../lib';

interface IMonthHeaderProps {
	settings: ICalendarPlusSettings;
	colorMode: ColorMode;
}
export const MonthHeader: React.FunctionComponent<IMonthHeaderProps> = ({ settings, colorMode }) => {
	return (
		<>
			{WEEK_DAYS.map((day, index) => (
				<Text
					borderBottom={'1px solid'}
					borderRight={WEEK_DAYS.length - 1 !== index ? '1px solid' : ''}
					borderColor={settings.styles[colorMode].calendarBordersColor}
					key={day}
					fontSize={{ base: 'xs', sm: 'sm' }}
					textAlign='center'
					w='full'
					height='full'
					p='0.5rem !important'
					mb='0px !important'
				>
					{day}
				</Text>
			))}
		</>
	);
};
